import * as Sentry from '@sentry/react';

import { isDev } from '~/dev/utils/isDev';

/** Stable tag values — never localized labels, which would break filtering. */
export type SidebarNavOptOutReason =
  | 'navigation'
  | 'broken'
  | 'habit'
  | 'other';

interface SubmitSidebarNavOptOutFeedbackParams {
  message: string;
  email?: string;
  name?: string;
  reasons?: SidebarNavOptOutReason[];
}

export const submitSidebarNavOptOutFeedback = ({
  message,
  email,
  name,
  reasons,
}: SubmitSidebarNavOptOutFeedbackParams) => {
  if (isDev) {
    console.info('[sidebar-nav opt-out feedback]', { message, reasons });
    return;
  }

  Sentry.captureFeedback(
    {
      message,
      name,
      email,
      url: window.location.href,
      source: 'sidebar-nav-opt-out',
    },
    {
      includeReplay: true,
      captureContext: {
        tags: {
          feedback_type: 'sidebar-nav-opt-out',
          // Left off entirely when unanswered, so Sentry groups them under
          // "(none)" rather than inventing a value we would have to explain.
          // A Sentry tag holds one value, so a multi-pick answer joins into a
          // single comma-separated key; one tag per reason keeps each of them
          // filterable on its own.
          ...(reasons?.length && {
            feedback_reason: reasons.join(','),
            ...Object.fromEntries(
              reasons.map((reason) => [`feedback_reason_${reason}`, 'true']),
            ),
          }),
        },
      },
    },
  );
};
